<template>
  <van-popup v-model="showDialogSelect" :close-on-click-overlay="false" position="bottom" @closed="onClosed">
    <van-nav-bar
      title="通过编号添加AIDA证书"
      left-text="返回"
      :right-text="buttonLoading?'提交中...':'提交'"
      left-arrow
      @click-left="showDialogSelect =false"
      @click-right="onAddCodeSearch"
    />
    <van-field
      v-if="!userData.lastName"
      label="英文姓(拼音)"
      :value="formData.lastName"
    />
    <van-field
      v-if="!userData.lastName"
      label="英文名(拼音)"
      :value="formData.firstName"
    />
    <van-field
      readonly
      label="证书编码"
      clickable
      :value="formData.code"
      @touchstart.native.stop="showNumberKeyBoard = true"
    />

    <div class="aboutImg">
      <img src="/img/aidaRegByCode.jpg">
    </div>

    <div class="aboutStr">
      1.请通过AIDA的电子证书编码绑定潜水证书；<br>
      2.请将如上图所示位置电子证书编码 例如:<b style="color:#f00">123456</b>填写进输入框；<br>
      3.查证需要一段时间，稍后会通过微信通知您结果。
    </div>
    <van-number-keyboard
      v-model="formData.code"
      close-button-text="完成"
      :show="showNumberKeyBoard"
      :maxlength="10"
      @blur="showNumberKeyBoard = false"
    />
  </van-popup>

</template>
<script>
import request from '@/utils/request'
import { Field, Popup, NumberKeyboard, NavBar, Dialog } from 'vant'
import { getUserBase } from '@/utils/base'
export default {
  components: {
    [Field.name]: Field,
    [NumberKeyboard.name]: NumberKeyboard,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog,
    [NavBar.name]: NavBar
  },
  props: {
    value: Boolean
  },
  data() {
    return {
      showDialogSelect: false,
      showNumberKeyBoard: false,
      buttonLoading: false,
      userData: {

      },
      formData: {
        code: '',
        lastName: '',
        firstName: '',
        birthday: null,
        img: null,
        groupType: 'AIDA',
        searchType: 'CODE',
        url: null
      }
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.showDialogSelect = true
      }
    }
  },
  created() {
    getUserBase(data => {
      this.userData = data
    }, true)
  },
  methods: {
    onClosed() {
      this.$emit('input', false)
    },
    onAddCodeSearch() {
      if (this.formData.searchType === 'CODE' && !this.formData.code) {
        this.showNumberKeyBoard = true
        return
      }
      if (this.buttonLoading) {
        return
      }
      this.buttonLoading = true
      request({
        url: '/user/addCodeImgCertificate',
        method: 'post',
        data: this.formData
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        this.formData.code = ''
        this.formData.img = ''
        Dialog.confirm({
          title: '提交成功',
          message: '资料已经提交成功,查证需要一段时间，稍后会通过微信通知您结果。',
          confirmButtonText: '继续添加',
          cancelButtonText: '返回'
        }).then(() => {

        }).catch(() => {
          this.showDialogSelect = false
        })
      })
    }
  }
}
</script>

<style scoped>
.aboutImg{
    padding: 1em 1em 0.5em 1em;
}
.aboutImg img{
    width: 100%;
}
.aboutStr{
    font-size: 0.8em;
    padding: 0 1em 2em 1em;
    color: #999;
}
</style>
